import { CreateButtonCss, isPhoneInLandscape } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import type { PopoverFooterProps } from '..'

export default (config: {
  props: Pick<PopoverFooterProps, 'dark'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  const secondaryButtonDarkStyles = {
    background: 'none',
    color: tokens.dark.fontColorDefault,

    '&:hover, &:focus-visible': {
      backgroundColor: tokens.dark.ctaBgColorTertiaryHover,
      color: tokens.dark.fontColorDefault,
    },

    '&:active': {
      backgroundColor: tokens.dark.ctaBgColorTertiaryActive,
      color: tokens.dark.fontColorDefault,
    },
  }

  return {
    default: {
      wrap: {
        justifyContent: 'flex-end',
      },

      content: {
        flex: '1 0 auto',
        margin: '0 16px 0 0',

        [isPhoneInLandscape]: {
          alignItems: 'stretch',
          flexDirection: 'column',
          margin: '0 0 16px 0',
          width: '100%',
        },
      },

      buttonsWrapper: {
        flex: '0 1 auto',

        'button, a': {
          '&:focus-visible': {
            outlineColor: props.dark ? tokens.dark.focusColor : undefined,
          },
        },

        [isPhoneInLandscape]: {
          alignItems: 'stretch',
          flexDirection: 'column',
          width: '100%',

          'button, a': {
            width: '100%',
          },
        },
      },

      primary: {
        marginInlineStart: '16px',

        'button, a': {
          ...(props.dark && {
            ...CreateButtonCss(tokens.button.primary).default,
          }),
        },

        [isPhoneInLandscape]: {
          margin: '0 0 8px 0',

          'button, a': {
            ...(props.dark && {
              ...CreateButtonCss(tokens.button.primary).default,
            }),
          },
        },
      },

      secondary: {
        'button, a': {
          ...(props.dark && { ...secondaryButtonDarkStyles }),
        },

        [isPhoneInLandscape]: {
          margin: '0',
          flex: '0 1 auto',

          'button, a': {
            width: '100%',
            ...(props.dark && {
              ...secondaryButtonDarkStyles,
            }),
          },
        },
      },
    },
  } as const
}
